import React from 'react'
import { useTranslation } from 'react-i18next'
import { TitleController } from '@pandiafi/design-system'
import {
  ResidentAppBackLink,
  ResidentAppCard,
  ResidentAppView,
} from '@pandiafi/components'

import { BulletinBoardDataLoader } from './BulletinBoardDataLoader'
import { ErrorHandler } from './BulletinBoardErrorHandler'
import { BulletinBoardList } from './BulletinBoardList'

import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'

export const BulletinBoardView: React.FC = () => {
  const { t } = useTranslation(['common', 'titles'])
  const { frontPagePath } = useContractPaths()

  return (
    <TitleController title={t('titles:bulletinBoard')}>
      <ResidentAppView
        title={t('common:views.bulletinBoard')}
        backLink={
          <ResidentAppBackLink href={frontPagePath}>
            {t('common:views.home')}
          </ResidentAppBackLink>
        }
      >
        <ResidentAppCard>
          <ErrorHandler>
            <BulletinBoardDataLoader>
              {({ bulletins }) => <BulletinBoardList bulletins={bulletins} />}
            </BulletinBoardDataLoader>
          </ErrorHandler>
        </ResidentAppCard>
      </ResidentAppView>
    </TitleController>
  )
}
